import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// X-TENANT-ID por-request (a tela de gestão opera sobre um único tenant), evitando mutar o
// header global default do apiService.
const tenantConfig = (tenantId?: string) =>
  tenantId ? { headers: { 'X-TENANT-ID': tenantId } } : undefined

export const getExecutarIntegracaoWhatsApp = async (
  tenantId?: string
): Promise<GetIntegracaoWhatsAppConfigType | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/integracaowhatsapp/config',
      tenantConfig(tenantId)
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const salvarIntegracaoWhatsApp = async (
  integracaoConfigRequestDTO: {},
  tenantId?: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      'app/integracaowhatsapp/config',
      {
        ...integracaoConfigRequestDTO,
      },
      tenantConfig(tenantId)
    )
    if (result.status === 200) {
      return { info: 'Integração whatsapp salva com sucesso!' }
    }
    if (result.status === 201) {
      return { info: 'Integração whatsapp criada com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const criarInstanciaWhatsApp = async (
  tenantId?: string
): Promise<PostCriarInstanciaWhatsApp | { message: string }> => {
  try {
    const result = await apiService.post(
      'app/integracaowhatsapp/instancia/criar',
      undefined,
      tenantConfig(tenantId)
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
